module.exports = __webpack_public_path__ + "img/arrow-left.ccd6dbf4.svg";